import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserSessionService, getDateObj } from '../../shared/shared';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CashierTransComponent } from '../../cashier/cashier-trans/cashier-trans.component';
import { RegPatService } from '../reg-pat-service/reg-pat-service'
import { RegPatServiceCancel, PatServiceCancel, CancelServiceService } from './cancel-service.service';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';
import { CallData } from '../../call-center/call-center-reservation/call-center-reservation.service';
import { NursingService, regPatMedicalSteps } from '../../orders/nursing/nursing.service';
import { IPromotionsMsgLog, MsgTemplate, SmsSendSetting } from '../../promotions/promotions';
import { PromotionOfferService } from '../../promotions/promotion-offer/promotion-offer.service';
import { SmsService } from '../../promotions/SmsService/Sms.service';
@Component({
  selector: 'sanabel-cancelService',
  templateUrl: './cancel-service.component.html',
  providers: [CancelServiceService]

})
export class CancelServiceComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  patService: any;
  patServiceArray: any[] = [];
  @Input() popClose: any;
  messagesLog: SmsSendSetting = <SmsSendSetting>{};
  msgTemplateData: any
  msgTemplate: MsgTemplate = <MsgTemplate>{};

  cancelServiceForm: UntypedFormGroup;
  regPatServiceCancel: RegPatServiceCancel;
  editPatService: RegPatService = <RegPatService>{};
  editRegPatServiceCancel: RegPatServiceCancel = <RegPatServiceCancel>{};
  callData: CallData = <CallData>{};
  editPatServiceCancel: PatServiceCancel = <PatServiceCancel>{};
  moreDatatoggle: boolean = false;
  @ViewChild(CashierTransComponent, { static: true }) cashierTransComponent: CashierTransComponent;

  constructor(
    private _cancelServiceService: CancelServiceService,
    public translate: TranslateService,
    private _SmsService: SmsService, private _NursingService: NursingService,
    private userSession: UserSessionService) {
  }

  ngOnInit() {

    this.cancelServiceInit();
    this.observeModal$();
    this.deleteAll$();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  observeModal$() {
    this.patServiceArray = [];
    this.userSession.getModalKey$()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {

        if (keys.name == 'CancelServiceComponent' && keys.inputs) {
          ;
          this.cancelServiceInit();

          this.patService = keys.inputs;
          this.patServiceArray = [keys.inputs];
          this.patService.smsTrigger = this.patService.smsTrigger

          this.patService.showSmsMsg = this.patService.sendMessageFlag
          this.msgTemplate.fieldName = this.patService.fieldName
          // if (this.patService.showSmsMsg)
          //   this.getMsgTemplate()
          this.cancelServiceForm.patchValue({ cancelReason: '' });
        }
      });
  }

  deleteAll$() {
    this.userSession.subscribeToKey$('deleteAll')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          this.cancelServiceInit();

          // this.patService = keys.inputs;
          this.patServiceArray = keys.value;
          this.patService.mobile = this.patServiceArray[0].mobile;
          this.patService.smsTrigger = this.patService.smsTrigger

          this.patService.showSmsMsg = this.patServiceArray[0].sendMessageFlag
          this.msgTemplate.fieldName = this.patServiceArray[0].fieldName
          // if (this.patService.showSmsMsg)
          // this.getMsgTemplate()
          this.cancelServiceForm.patchValue({ cancelReason: '' });
        }
      });
  }

  cancelServiceInit() {

    this.cancelServiceForm = new UntypedFormGroup({
      cancelReason: new UntypedFormControl(),
      cancelReasonHeader: new UntypedFormControl()
    });
    this.patService = this.userSession.getModalKey('CancelServiceComponent')["inputs"];
    if (this.patService) {
      this.patService.showSmsMsg = this.patService.sendMessageFlag
      this.patService.smsTrigger = this.patService.smsTrigger
      this.msgTemplate.fieldName = this.patService.fieldName
      //if (this.patService.showSmsMsg)
      // this.getMsgTemplate()
    }
  }

  saveServiceStatus() {
    let type = 1;
    if (this.patService.type && this.patService.type != null) {
      type = this.patService.type;
    }
    if (this.patServiceArray.length > 0) {
      type = this.patServiceArray[0].type ? this.patServiceArray[0].type : 1
    }
    if (type == 10) {
      this.callData.serial = this.patService.serial
      this.callData.cancelReason = this.cancelServiceForm.get('cancelReasonHeader').value;
      this.callData.cancelNotes = this.cancelServiceForm.get('cancelReason').value;
      this._cancelServiceService.CCcallDataArriveResultCancel(this.callData)
        .subscribe((c) => {
          if (c["returnFlag"]) {
            if (this.patService.sendMessageFlag)
              this.saveMessagesLog(5)
            this.userSession.closeModalKey('CancelServiceComponent', c);

          }
        });
      return;
    }
    else if (type == 11) { // one
      let servStep = <regPatMedicalSteps>{};
      servStep.serial = this.patService.serial;
      servStep.regPatMedicalStepsSerial = this.patService.serial
      servStep.cancelReasonCode = this.cancelServiceForm.get('cancelReasonHeader').value;
      servStep.cancelNotes = this.cancelServiceForm.get('cancelReason').value;
      let arr = [];
      arr.push(servStep);
      this._NursingService.cancelRegPatMedicalSteps(arr)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(c => {
          if (c["returnFlag"]) {
            if (this.patService.sendMessageFlag)
              this.saveMessagesLog(7)

            this.userSession.closeModalKey('CancelServiceComponent', c);
          }

        })
      return;

    }
    else if (type == 12) { // array
      let arr = [];
      for (let index = 0; index < this.patServiceArray.length; index++) {
        arr.push({
          serial: this.patServiceArray[index].serial * -1,
          regPatMedicalStepsSerial: this.patServiceArray[index].serial,
          priServiceStpMedicalStepId: this.patServiceArray[index].priServiceStpMedicalStepId,
          cancelReasonCode: this.cancelServiceForm.get('cancelReasonHeader').value,
          cancelNotes: this.cancelServiceForm.get('cancelReason').value
        });
      }

      this._NursingService.cancelRegPatMedicalSteps(arr)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(c => {
          if (c["returnFlag"]) {
            if (this.patService.sendMessageFlag)
              this.saveMessagesLog(7)

            this.userSession.closeModalKey('CancelServiceComponent', c);
          }

        })
      return;

    }

    this.editRegPatServiceCancel.serial = 0;
    this.editRegPatServiceCancel.deletedSerial = this.patService.regPatServiceSerial;
    this.editRegPatServiceCancel.cancelReason = this.cancelServiceForm.get('cancelReason').value;
    this.editRegPatServiceCancel.cancelReasonHeader = this.cancelServiceForm.get('cancelReasonHeader').value;
    this.editRegPatServiceCancel.visitSerial = this.patService.visitSerial;
    this.editRegPatServiceCancel.transDate = getDateObj(this.patService.startDate);
    //----------------------------------------------------
    this.editPatService.serial = this.patService.regPatServiceSerial;
    this.editPatService.servStatus = 5;

    this.editPatService.serviceId = this.patService.serviceId;
    this.editPatService.visitSerial = this.patService.visitSerial;
    //----------------------------------------------------
    this.editPatServiceCancel.RegPatService = this.editPatService;
    this.editPatServiceCancel.RegPatServiceCancel = this.editRegPatServiceCancel;
    this.patService.ServStatus = 5;
    this.editRegPatServiceCancel.type = type;
    this.editRegPatServiceCancel.recieptCancelFlag = this.patService.recieptCancelFlag;
    if (type == 1 || type == 5 || type == 6 || type == 7) {
      this._cancelServiceService.SavePatServiceCancellation(this.editPatServiceCancel)
        .subscribe((service) => {
          if (service["returnFlag"]) {
            this.userSession.closeModalKey('CancelServiceComponent', service);
          }
        });
    }
    else if (type == 4) {
      this._cancelServiceService.SaveAccomodationCancelation(this.editRegPatServiceCancel)
        .subscribe((c) => {
          if (c["returnFlag"]) {
            this.userSession.closeModalKey('CancelServiceComponent', c);
          }
        });
    }
    else if (type == 2 || type == 3) {
      this.editRegPatServiceCancel.deletedSerial = this.patService.billPatServiceSerial;
      this._cancelServiceService.SaveItemsCancelation(this.editRegPatServiceCancel)
        .subscribe((c) => {
          if (c["returnFlag"]) {
            this.userSession.closeModalKey('CancelServiceComponent', c);
          }
        });
    }

  }

  onClicked(e: number): void {
    switch (e) {
      case 1: //save code
        this.saveServiceStatus();
        break;

    }

  }
  callDataSerial: number
  //data of sms message
  saveMessagesLog(type: number) {
    //get template message
    // if (this.msgTemplateData) {
    // if (this.msgTemplateData.smsTemplate) {

    let sendData: any = {}
    sendData = this.patService
    sendData.messageType = 5;
    if (sendData.reservationDate) {
      var event = new Date(sendData.reservationDate);
      let dayName = event.toLocaleDateString('ar-EG', { weekday: 'long' })
      sendData.reservationDateMsg = sendData.reservationDate.toString().slice(0, 16).replace('T', '  الساعة');
    }// sendData.reservationDate = this.patService.reservationDate
    sendData.doctorName = this.patService.docNameAr
    sendData.deviceName = this.patService.deviceName
    this._SmsService.SendSmsData(sendData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {

      })
    //create message
    // this.replacrDatainSms()
    // //meesage data
    // this.messagesLog.serial = -1
    // this.messagesLog.patCode = this.patService.patCode
    // this.messagesLog.message = this.msgTemplateData.smsTemplate
    // this.messagesLog.sentDate = new Date()
    // this.messagesLog.sender = +JSON.parse(sessionStorage.getItem('currentUser')).userID
    // this.messagesLog.mobile = this.patService.mobile;
    // this.messagesLog.callDataSerial = this.patService.serial;
    // this.messagesLog.messageType = 5 //رساله الالغاء حجز مريض
    // this._SmsService.RemindingBookingMsg([this.messagesLog])
    //     .pipe(takeUntil(this.ngUnsubscribe))
    //     .subscribe(res => {

    //     })
    // }
    // }
  }
  templateMsg: string = ""
  replacrDatainSms() {

    let SmsData = <any>{
      reservationDate: this.patService.reservationDate,
      doctorName: this.patService.docNameAr,
      deviceName: this.patService.deviceName
    };
    this.msgTemplateData.smsTemplate = this._SmsService.replaceSmSMsgData(SmsData, this.templateMsg)
    console.log(this.msgTemplateData.smsTemplate)
    // var event = new Date(this.patService.reservationDate);

    // let dayName = event.toLocaleDateString('ar-EG', { weekday: 'long' })
    // let date = this.patService.reservationDate.toString().slice(5, 16).replace('T', '  الساعة');
    // date = dayName.concat(date)
    // this.msgTemplateData.smsTemplate = this.templateMsg.replace('{{this.doctorName}}', this.patService.docNameAr)
    //     .replace('{{this.reservationDate}}', date).replace('{{deviceName}}',
    //         this.patService.deviceName)
    // console.log(this.msgTemplateData.smsTemplate)
  }
  // getMsgTemplate() {
  //   this._SmsService.getMsgTemplate(this.msgTemplate)
  //     .pipe(takeUntil(this.ngUnsubscribe))
  //     .subscribe(
  //       res => {
  //         if (res && res.data) {
  //           this.msgTemplateData = res.data[0];
  //           this.templateMsg = this.msgTemplateData.smsTemplate

  //         }
  //       }
  //     )
  // }
}
